const { useEffect, useState } = wp.element;

const Component = ({ bookingData, category, service, setService, byResource, employee }) => {
    const [parentService, setParentService] = useState(null)

    console.log('bookingData', bookingData)

    useEffect(() => {
        setParentService(null)
    }, [category])
    
    useEffect(() => {
        // scroll down to next section
        if (parentService) {
            const nextSection = document.getElementById('section-service-subitems')
            if (nextSection) {
                nextSection.scrollIntoView({ behavior: 'smooth' })
            }
        }
    }, [parentService])

    const keys = [
        'hano-id',
        'hano-id-senior',
        'hano-id-elite',
        'hano-id-larling-2',
        'hano-id-larling-3',
        'hano-id-larling-4',
    ]

    function filterOutNotProvidedServices(items) {
        return items.filter(item => {
            if (item['is-service'] === false) {
                return true
            }
            
            let match = false
            
            keys.forEach(key => {
                if (employee.provides.find(provided => String(provided.id) === String(item[key]))) {
                    match = true
                }
            })
            
            return match
        })
    }
    
    let packageItems = !byResource ? bookingData?.package?.items : filterOutNotProvidedServices(bookingData?.package?.items)
    let menItems = !byResource ? bookingData?.men?.items : filterOutNotProvidedServices(bookingData?.men?.items)
    let cutItems = !byResource ? bookingData?.cut?.items : filterOutNotProvidedServices(bookingData?.cut?.items)
    let colorItems = !byResource ? bookingData?.color?.items : filterOutNotProvidedServices(bookingData?.color?.items)
    let stylingItems = !byResource ? bookingData?.styling?.items : filterOutNotProvidedServices(bookingData?.styling?.items)
    let otherItems = !byResource ? bookingData?.other?.items : filterOutNotProvidedServices(bookingData?.other?.items)

    return (
        <>
            <div className="section" id="section-service">
                <div className="container grid">
                    <h2 className="section-title">Velg type behandling</h2>

                    <div className="items">
                        <div className="container">
                            {
                                category === 'package' &&
                                packageItems?.length > 0 &&
                                <>
                                    {
                                        packageItems?.map((item, key) => {
                                            return (
                                                <button onClick={() => { setService(item); setParentService(null) }} key={key} className={`item ${service?.['hano-id'] === item['hano-id'] ? 'active' : ''}`}>
                                                    <span>
                                                        <h3 className="item-title">{item.name}</h3>
                                                        <p className="item-description">{item.description}</p>
                                                    </span>
                                                </button>
                                            )
                                        })
                                    }
                                </>
                            }
                            
                            {
                                category === 'men' &&
                                menItems?.length > 0 &&
                                <>
                                    {
                                        menItems?.map((item, key) => {
                                            return (
                                                <button onClick={item['is-service'] === false ? () => { setParentService(item) } : () => { setService(item); setParentService(null) }} key={key} className={`item ${service?.['hano-id'] === item['hano-id'] || parentService?.name === item.name ? 'active' : ''}`}>
                                                    <span>
                                                        <h3 className="item-title">{item.name}</h3>
                                                        <p className="item-description">{item.description}</p>
                                                    </span>
                                                </button>
                                            )
                                        })
                                    }
                                </>
                            }

                            {
                                category === 'cut' &&
                                cutItems?.length > 0 &&
                                <>
                                    {
                                        cutItems?.map((item, key) => {
                                            return (
                                                <button onClick={item['is-service'] === false ? () => { setParentService(item) } : () => { setService(item); setParentService(null) }} key={key} className={`item ${service?.['hano-id'] === item['hano-id'] || parentService?.name === item.name ? 'active' : ''}`}>
                                                    <span>
                                                        <h3 className="item-title">{item.name}</h3>
                                                        <p className="item-description">{item.description}</p>
                                                    </span>
                                                </button>
                                            )
                                        })
                                    }
                                </>
                            }

                            {
                                category === 'color' &&
                                colorItems?.length > 0 &&
                                <>
                                    {
                                        colorItems?.map((item, key) => {
                                            return (
                                                <button onClick={() => { setService(item); setParentService(null) }} key={key} className={`item ${service?.['hano-id'] === item['hano-id'] ? 'active' : ''}`}>
                                                    <span>
                                                        <h3 className="item-title">{item.name}</h3>
                                                        <p className="item-description">{item.description}</p>
                                                    </span>
                                                </button>
                                            )
                                        })
                                    }
                                </>
                            }

                            {
                                category === 'styling' &&
                                stylingItems?.length > 0 &&
                                <>
                                    {
                                        stylingItems?.map((item, key) => {
                                            return (
                                                <button onClick={() => { setService(item); setParentService(null) }} key={key} className={`item ${service?.['hano-id'] === item['hano-id'] ? 'active' : ''}`}>
                                                    <span>
                                                        <h3 className="item-title">{item.name}</h3>
                                                        <p className="item-description">{item.description}</p>
                                                    </span>
                                                </button>
                                            )
                                        })
                                    }
                                </>
                            }

                            {
                                category === 'other' &&
                                otherItems?.length > 0 &&
                                <>
                                    {
                                        otherItems?.map((item, key) => {
                                            return (
                                                <button onClick={() => { setService(item); setParentService(null) }} key={key} className={`item ${service?.['hano-id'] === item['hano-id'] ? 'active' : ''}`}>
                                                    <span>
                                                        <h3 className="item-title">{item.name}</h3>
                                                        <p className="item-description">{item.description}</p>
                                                    </span>
                                                </button>
                                            )
                                        })
                                    }
                                </>
                            }

                            {
                                (
                                    (
                                        category === 'package' &&
                                        packageItems?.length === 0
                                    ) ||
                                    (
                                        category === 'men' &&
                                        menItems?.length === 0
                                    ) ||
                                    (
                                        category === 'cut' &&
                                        cutItems?.length === 0
                                    ) ||
                                    (
                                        category === 'color' &&
                                        colorItems?.length === 0
                                    ) ||
                                    (
                                        category === 'styling' &&
                                        stylingItems?.length === 0
                                    ) ||
                                    (
                                        category === 'other' &&
                                        otherItems?.length === 0
                                    )
                                ) &&
                                <p className="no-items">{employee.name} tilbyr ikke behandlinger innen denne kategorien.</p>
                            }
                        </div>
                    </div>
                </div>

                {
                    service &&
                    <svg className="progress-arrow" width="64" height="32" viewBox="0 0 64 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M0 0H64L32 32L0 0Z" fill="currentColor"/>
                    </svg>
                }
            </div>

            {
                parentService && 
                parentService['sub-items'] &&
                <div className="section" id="section-service-subitems">
                    <div className="container grid">
                        <h2 className="section-title">Spesifiser behandling</h2>

                        <div className="items">
                            <div className="container">
                                {
                                    parentService['sub-items'].map((subitem, key) => {
                                        return (
                                            <button onClick={() => { setService(subitem) }} key={key} className={`item ${service?.['hano-id'] === subitem['hano-id'] ? 'active' : ''}`}>
                                                <span>
                                                    <h3 className="item-title">{subitem.name}</h3>
                                                    <p className="item-description">{subitem.description}</p>
                                                </span>
                                            </button>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default Component;